import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@net0-calc/common/assets/styles/fonts.css';
import { initSupabase } from '@net0-calc/common/services';
import { config } from './config';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Supabase client
initSupabase(config.SUPABASE_URL, config.SUPABASE_ANON_KEY);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
